import * as React from 'react';
import { Button } from '@ghq-abi/design-system-v2';
import { useTranslate } from '@tolgee/react';

import { useResponsive } from '~/shared/hooks';
import { cn } from '~/shared/utils/cn';

import { Icon } from '../Icon';

type FilterButtonProps = {
  isShowingFilters: boolean;
  disabled: boolean;
  size?: 'sm' | 'md' | 'lg';
  onClick: () => void;
};

const sizeClasses = {
  sm: 'h-8 w-8',
  md: 'h-10 w-10',
  lg: 'h-12 w-12',
} as const;

export function FilterButton({
  isShowingFilters,
  disabled,
  size,
  onClick,
}: FilterButtonProps) {
  const { t } = useTranslate();

  const { isMobile } = useResponsive({ useOnlyAbiTokens: true });

  const sizeIcon = size || (isMobile ? 'sm' : 'md');

  return (
    <Button
      variant="secondary"
      size="icon"
      className={cn(sizeClasses[sizeIcon])}
      title={`${isShowingFilters ? t('common.hide') : t('common.show')} ${t(
        'common.filters'
      )}`}
      onClick={onClick}
      disabled={disabled}
    >
      {isShowingFilters ? (
        <Icon isCustom icon="filterCircleFill" />
      ) : (
        <Icon isCustom icon="filterCircle" />
      )}
    </Button>
  );
}
